import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LanguageModel} from '../../../../models/language.model';
import {UserModel} from '../../../../models/user.model';
import {PublicationModel} from '../../../../models/publication.model';
import {HistoryModel} from '../../../../models/historyModel';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationService} from 'primeng/api';
import {I18nService} from '../../../../../shared/i18n';
import {IsbnService} from '../../../../services/isbn.service';
import {IsbnModel, IsbnPageAbleModel} from '../../../../models/isbn.model';
import {PublicationService} from '../../../../services/publication.service';
import {NotificationService} from '../../../../../shared/utils/notification.service';
import * as FileSaver from 'file-saver';
import {HistoryService} from '../../../../services/history.service';
import {ReportService} from '../../../../services/report.service';
import {AppCommunicationService} from '../../../../services/app-communication.service';

@Component({
    selector: 'app-supervisors-form-part',
    templateUrl: './supervisors-form-part.component.html',
    styleUrls: ['./supervisors-form-part.component.scss']
})
export class SupervisorsFormPartComponent implements OnInit {


    @Output('onIsbnChoosen')
    onIsbnChoosen = new EventEmitter<number>();
    @Output('onIsbnAssign')
    onIsbnAssign = new EventEmitter<boolean>();
    @Output('onCommentChanged')
    onCommentChanged = new EventEmitter<string>();
    comment='';

    @Input() publication: PublicationModel = new PublicationModel();
    @Input() allActionHistory: HistoryModel[];
    @Input() isbnReportGenerateAction:HistoryModel;
    @Input() pvReportGenerateAction:HistoryModel;
    isIsbnChoosen=false;


    selectedIsbn:any;
    pTable = {
        colNumber: 5,
        expandedRows: {}
    };
    selectISBN = {
        data: [],
        settings: {
            singleSelection: true,
            idField: 'item_id',
            textField: 'item_text',
            selectAllText: 'Označiť všetko',
            unSelectAllText: 'Odznačiť všetko',
            itemsShowLimit: 1,
            allowSearchFilter: true
        }
    };

    customIsbn=false;
    constructor(private confirmationService:ConfirmationService,
                private publicationService:PublicationService,
                private i18nService:I18nService,
                private isbnService:IsbnService,
                private notificationService: NotificationService,
                private route: ActivatedRoute,
                private reportService:ReportService,
                private _appCommunicationService: AppCommunicationService) {
    }

    ngOnInit() {
    }


    private generateSelectIsbnData() {
        this.isbnService.getUnusedisbns().subscribe((data:IsbnPageAbleModel)=> {
           this.selectISBN.data=[];
            this.selectISBN.data.push(... data.items.map(i =>({
                item_id: i.id, item_text: i.dirtyNumber})));
        },err=>console.error(err));
    }


    onRemoveIsbnClick() {
        this.notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmation'),
            content: this.i18nService.getTranslation('confirmRemoveIsbn'),
            buttons: '['+this.i18nService.getTranslation('No')+']['+
            this.i18nService.getTranslation('Yes')+']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes') ) {
                setTimeout(() => {
                    this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Loading data'));
                });
                this.isbnService.setIsbnUnused(this.publication.id).subscribe(data=> {
                    this.publication.isbn='';
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('saved'),
                        color: '#659265',
                        content: this.i18nService.getTranslation('isbnwasdeleted'),
                        timeout: 8000
                    });
                    this._appCommunicationService.loadingOff()
                },err => {
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('error'),
                        color: '#923837',
                        iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                        content: this.i18nService.getTranslation('somethingIsWrongError'),
                        timeout: 10000
                    });
                    this._appCommunicationService.loadingOff();
                    console.log(err)
                });
                this.publication.isbn='';
            }
        });
    }
    onPrintDeliveryClick() {
        this.notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmation'),
            content: this.i18nService.getTranslation('confirmPrintsDelivery'),
            buttons: '['+this.i18nService.getTranslation('No')+']['+
            this.i18nService.getTranslation('Yes')+']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes') ) {
                this.publicationService.acceptPrints(this.publication.id).subscribe(() => {
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('saved'),
                        color: '#659265',
                        content: this.i18nService.getTranslation('printsHasBeenAccepted'),
                        timeout: 8000
                    });
                    this.publication.isPrintDelivered=true;
                },err=> {
                    console.error(err);
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('error'),
                        color: '#923837',
                        iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                        content: this.i18nService.getTranslation('somethingIsWrongError'),
                        timeout: 10000
                    });
                })
            }
        });
    }
    onCustomIsbn() {

        this.notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmation'),
            content: this.i18nService.getTranslation('confirmCustomIsbn'),
            buttons: '['+this.i18nService.getTranslation('No')+']['+
            this.i18nService.getTranslation('Yes')+']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes') ) {
                this.generateSelectIsbnData();
                this.customIsbn=true;
            }
        });
    }
    onAssignIsbn() {
        this.isIsbnChoosen=true;
        this.onIsbnAssign.emit(this.isIsbnChoosen);
    }
    onChangedComment() {
        this.onCommentChanged.emit(this.comment);
    }
    onAssignIsbnCustom($event) {
        this.selectedIsbn=$event;
        this.onIsbnChoosen.emit(this.selectedIsbn.item_id );
        this.onAssignIsbn()
    }
    onRevertIsbn() {
        this.isIsbnChoosen=false;
        this.onIsbnAssign.emit(this.isIsbnChoosen);
    }
    onBackToAutomatically() {
        this.customIsbn=false;
        this.onIsbnChoosen.emit(0);
    }

    onDownloadCertClick() {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Downloading report'));
        });
        this.publicationService.downloadPrintCertification(this.publication.id).subscribe(
            (data:Blob)=> {
                FileSaver.saveAs(data, 'certificate.pdf');
                this._appCommunicationService.loadingOff();
            },err=> {
                console.error(err);
                this._appCommunicationService.loadingOff();
                this.notificationService.smallBox({
                    title: this.i18nService.getTranslation('error'),
                    color: '#923837',
                    iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                    content: this.i18nService.getTranslation('somethingIsWrongError'),
                    timeout: 10000
                });
            });
    }

    onDownloadIsbnReport(rowData:HistoryModel) {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Downloading report'));
        });
        const idReport=+(rowData.id.split('-')[1]);
        this.reportService.downloadIsbnReport(idReport).subscribe(
            (data:Blob)=> {
                FileSaver.saveAs(data, 'ISBN_Report.pdf');
                this._appCommunicationService.loadingOff();
            },err=> {
                console.error(err);
                this._appCommunicationService.loadingOff();
                this.notificationService.smallBox({
                    title: this.i18nService.getTranslation('error'),
                    color: '#923837',
                    iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                    content: this.i18nService.getTranslation('somethingIsWrongError'),
                    timeout: 10000
                });
            });
    }

    onDownloadPrints(rowData:HistoryModel,type:string) {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Downloading report'));
        });
        let rest;
        const idReport=+(rowData.id.split('-')[1]);
        switch (type) {
            case 'all':{
                rest = this.reportService.downloadPrintReport(idReport);
                break;
            }
            case 'ke':{
                rest = this.reportService.downloadKePrintReport(idReport);
                break;
            }
            case 'ba':{
                rest = this.reportService.downloadBaPrintReport(idReport);
                break;
            }
            case 'mt':{
                rest = this.reportService.downloadMtPrintReport(idReport);
                break;
            }
            case 'SVK_BB':{
                rest = this.reportService.downloadSvkBbPrintReport(idReport);
                break;
            }
            case 'SVK_KE':{
                rest = this.reportService.downloadSvkKePrintReport(idReport);
                break;
            }
            case 'SVK_PO':{
                rest = this.reportService.downloadSvkPoPrintReport(idReport);
                break;
            }
            case 'UK_SAV_BA':{
                rest = this.reportService.downloadUkSavBaPrintReport(idReport);
                break;
            }
            case 'PK_NRSR':{
                rest = this.reportService.downloadPkNrsrPrintReport(idReport);
                break;
            }
            case 'CVTI_SR':{
                rest = this.reportService.downloadCvtiSrPrintReport(idReport);
                break;
            }
        }
        rest.subscribe(
            (data:Blob)=> {
                FileSaver.saveAs(data, 'Prints_Report('+type+').pdf');
                this._appCommunicationService.loadingOff();
            },err=> {
                console.error(err);
                this._appCommunicationService.loadingOff();
                this.notificationService.smallBox({
                    title: this.i18nService.getTranslation('error'),
                    color: '#923837',
                    iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                    content: this.i18nService.getTranslation('somethingIsWrongError'),
                    timeout: 10000
                });
            });
    }


}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/publication-registration/base-publication-form-part/supervisors-form-part/supervisors-form-part.component.ts